export const designTokens = {
    // Font family
    fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',

    // Color palette
    colors: {
        // Primary Colors
        primary: '#3378A5',
        // primary: '#005CAA',
        primary50: '#3378A580',       // Hover states
        // primary50: '#005CAA80',       // Hover states
        primaryDark: '#2A6388',       // Active, pressed states
        // primaryDark: '#004A8C',       // Active, pressed states
        primaryLight: '#8BBBDA',      // Disabled states
        buttonDisabled: '##8BBBDA',    // Disabled button background
        // buttonDisabled: '#769AB8',    // Disabled button background

        white: '#FFFFFF',
        black: '#1F1F1F',

        red: {
            main: '#DC7663',
            light: '#ECB6AC',
            dark: '#D65E48',
            main50: '#DC766380'
        },

        yellow: {
            main: '#E4B53D',
            dark: '#E0AA1F',
            light: '#FFF9E6',
        },

        blue: {
            main: '#214572',
            light: '#C9E9FF',
        },

        green: {
            main: '#6FAA83'
        },

        // CatalogTable Colors
        table: {
            // headerBg: '#005CAA',
            headerBg: '#4A90B5',
            // sectionBg: '#005CAA',
            sectionBg: '#4A90B5',
            selectedRowBg: '#E5E7EB',
            rowText: '#1E2939',
        },

        grey: {
            100: '#F3F5F7',
            200: '#E8EBED',
            300: '#A1AAB2',
            400: '#697885',
            500: '#535862',
            600: '#717680',
            700: '#414651'
        },

        // Text Colors
        text: {
            primary: '#1F1F1F',
            heading: '#181D27',
            secondary: '#697885',
            disabled: '#8BBBDA',
            white: '#FFFFFF',
        },

        // UI Colors
        border: '#E8EBED',
        divider: '#E8EBED',

        // Backgrounds
        background: {
            page: '#FFFFFF',
            card: '#FFFFFF',
            input: '#F3F5F7',
            nav: {
                main: '#F8F8F8',
                hover: '#E1E1E1',
                active: '#E1E1E1',
                accent: '#F0F0F0',
            },
            statusbar: '#F8F8F8',
            tooltip: '#FFFFFF',
        },

        // Navigation Colors
        nav: {
            textActive: '#252B37',
            textInactive: '#414651',
            icon: '#6A6A6A',
        },
    },

    // Typography scale
    typography: {
        h1: {
            fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
            fontSize: '24px',
            fontWeight: 500,
            lineHeight: '1.2',
            color: '#1F1F1F',
            letterSpacing: '0',
        },
        h2: {
            fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
            fontSize: '20px',
            fontWeight: 500,
            lineHeight: '24px',
            color: '#1F1F1F',
            letterSpacing: '0',
        },
        h3: {
            fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
            fontSize: '18px',
            fontWeight: 500,
            lineHeight: '22px',
            color: '#1F1F1F',
            letterSpacing: '0',
        },
        h4: {
            fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '22px',
            color: '#3378A5',
            letterSpacing: '0',
        },
        subtitle: {
            fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
            fontSize: '15px',
            fontWeight: 400,
            lineHeight: '20px',
            color: '#535862',
            letterSpacing: '0',
        },
        body: {
            fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
            fontSize: '15px',
            fontWeight: 500,
            lineHeight: '20px',
            color: '#1F1F1F',
            letterSpacing: '0',
        },
        label: {
            fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
            fontSize: '13px',
            fontWeight: 400,
            lineHeight: '18px',
            color: '#A1AAB2',
            letterSpacing: '0',
        },
        button: {
            fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
            fontSize: '16px',
            fontWeight: 500,  
            lineHeight: '25px',
            textTransform: 'none',
            letterSpacing: '0',
        },
        placeholder: {
            fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
            fontSize: '17px',
            fontWeight: 400,  
            lineHeight: '100%',
            color: '#A1AAB2',
            textTransform: 'none',
            letterSpacing: '0',
        },
        error: {
            fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
            fontSize: '12px',
            fontWeight: 400,
            lineHeight: '16px',
            color: '#DC7663',
            letterSpacing: '0',
        },
        // Catalog Table typography
        tableRow: {
            fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
            fontSize: '16px',
            fontWeight: 400,
            lineHeight: '24px',
            color: '#1E2939',
            letterSpacing: '-0.31px',
        },
        tableHeader: {
            fontFamily: '"PP Neue Montreal", -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
            fontSize: '16px',
            fontWeight: 500,
            lineHeight: '24px',
            color: '#FFFFFF',
            letterSpacing: '0',
        },
    },

    // Spacing scale
    spacing: {
        xs: '4px',
        sm: '8px',
        md: '12px',
        lg: '16px',
        xl: '24px',
        xxl: '32px',
        xxxl: '40px',
    },

    // Border Radius
    borderRadius: {
        button: '6px',
        card: '6px',
        input: '8px',
        modal: '10px',
    },
};

export const getColor = (path) => {
    const keys = path.split('.');
    let value = designTokens.colors;
    for (const key of keys) {
        value = value[key];
    }
    return value;
};

export const getSpacing = (size) => `${designTokens.spacing[size]}px`;

export const getBorderRadius = (type) => `${designTokens.borderRadius[type]}px`;
